//弹框辅助类
class PopLayer {

    constructor(options) {
        this.entity = options.entity; //绑定实体
        this.dialog = options.dialog;// 弹框插件
        this.componet = options.componet;// 弹框内容
        this.title = options.title;// 弹框标题
        this.subData = options.subData || {};// 弹框数据
        this.width = options.width || 380;// 弹框数据
        this.height = options.height || 260;// 弹框数据
        this.height_off = options.height_off || 0;// 弹框数据
        this.animation = options.animation;
        this.onOpen = options.onOpen;// 弹框打开时回调
        this.onClose = options.onClose;// 弹框关闭时回调
        this.isShow = false;
        this.layer = undefined;
        this.currentItem = null;// 当前位置
        this.init();//初始化
    }
    init() {
        var that = this;
        this.handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
        this.handler.setInputAction((evt) => {
            if (that.isShow) {
                return;
            }
            let pick = viewer.scene.pick(evt.position);
            var entity = that.getPickEnity(pick);
            if (entity && entity == that.entity) {
                that.open();
            }

        }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
        viewer.scene.postRender.addEventListener((e) => {
            that.postRender(e);
        });
    }
    close() {


        if (this.isShow && this.layer && this.layer.close) {
            this.layer.close();
            console.log(this.layer)
            //this.layer = null;
        }


        this.cancelPop(); // cancelPop 内部已触发 onClose 回调

        if (this.timerIndex) {
            clearInterval(this.timerIndex)
        }

    }
    cancelPop() {
        this.isShow = false;
        // 弹窗关闭时触发回调（清理轨迹线等）
        if (this.onClose && typeof this.onClose === 'function') {
            this.onClose(this.entity);
        }
    }
    postRender(e) {
        if (!this.isShow || !this.layer) {
            return;
        }

        this.update();
    }
    getPickEnity(pick) {
        if (Cesium.defined(pick) && (pick.id)) {
            return pick.id;
        }

        return null;
    }
    open() {
        if (!this.entity || !this.entity.position || !this.entity.position.getValue) {
            return;
        }
        var cartesian = this.entity.position.getValue(viewer.clock.currentTime);//
        var winpos = viewer.scene.cartesianToCanvasCoordinates(
            cartesian
        );
        if (!winpos || !winpos.x || !winpos.y) {
            return;
        }
        var pageX = winpos.x;
        var pageY = winpos.y - this.height;
        this.layer = this.dialog.open({
            hasHead: false,
            shade: false,
            hasMin: false,
            move: false,
            title: this.title,
            theme: "super-dialog",
            cancel: () => { this.cancelPop() },
            location: {
                left: pageX + "px",
                top: pageY + "px",
                right: undefined,
                bottom: undefined
            },
            area: {
                height: this.height + "px",
                width: this.width + "px",
            },
            content: {
                type: "vue",
                subCom: this.componet,
                subData: this.subData
            },
        });
        this.isShow = true;

        // 触发打开回调
        if (this.onOpen && typeof this.onOpen === 'function') {
            this.onOpen(this.entity, this.subData);
        }


        if (this.animation && this.animation.originPath) {
            this.updateCurrentItem();

            this.timerIndex = setInterval(() => {
                if (this.animation && !this.animation._isStart) {
                    if (this.timerIndex) {
                        clearInterval(this.timerIndex)
                    }
                }
                if (this.layer && this.layer.$children && this.layer.$children.length && this.layer.$children[0].updateOther) {
                    this.updateCurrentItem();
                    this.layer.$children[0].updateOther(this.currentItem, this.curPos);

                    // console.log("originPath", this.animation.originPath)
                    // console.log("passIndex", this.animation.passIndex)
                }

            }, 2000)
        }
    }
    //更新当前对象
    updateCurrentItem() {
        let item = null;
        if (this.animation && this.animation.originPath) {
            if (this.animation) {
                item = this.animation.getItem();
            }
            this.currentItem = item || this.currentItem;
        }
    }

    update() {
        if (!this.entity || !this.entity.position || !this.entity.position.getValue) {
            return;
        }
        var cartesian = this.entity.position.getValue(viewer.clock.currentTime);//
        var winpos = viewer.scene.cartesianToCanvasCoordinates(
            cartesian
        );
        if (!winpos || !winpos.x || !winpos.y) {
            return;
        }
        var pageX = winpos.x
        var pageY = winpos.y - this.height - this.height_off;
        this.layer.auto_location({
            left: pageX + "px",
            top: pageY + "px",
            right: undefined,
            bottom: undefined
        });

        var carto = Cesium.Cartographic.fromCartesian(cartesian);
        if (carto == null) return null;

        var x = Cesium.Math.toDegrees(carto.longitude);
        var y = Cesium.Math.toDegrees(carto.latitude);
        var z = carto.height;

        this.curPos = {
            x: x,
            y: y,
            z: z
        }
        // let item = null;
        // if (this.animation) {
        //     item = this.animation.getItem();
        // }

        // this.currentItem = item || this.currentItem;
        // console.log(this.currentItem)
        //this.layer.$children[0].update(x, y, z, this.currentItem);
    }
}

export default PopLayer;